export const APP_STATUS_TEXTS = {
    maintenance: 'Under maintenance',
    unknown: 'Unknown status',
};
